import type { ILeadsSearchFiltersState } from "./types/state";

export const INITIAL_LEADS_SEARCH_FILTERS_STATE: ILeadsSearchFiltersState = {
    filters: {},
};
